module.exports = __webpack_public_path__ + "img/kn.96f11c25.svg";